import React, { useState } from 'react';
import { rd } from '@passionware/monads';

import { CellResource, Grid, GridCell, PressStud } from 'v1/components/shared';
import { useBrowsingWorkspaceRoutes } from 'v5/core/app-scope/useBrowsingWorkspaceRoutes';
import { useResourceDuplicates } from 'v5/features/resources/form/useResourceDuplicates';
import { myServices } from 'v5/services/services.connected.app';

import styles from './ResourceDuplicates.module.scss';

/**
 * Resources of the browsing scope whose name contains `candidate`'s.
 * Dismissing hides the current set of matches; a different set shows again.
 *
 * @param {{ candidate: import('v5/features/resources/form/useResourceDuplicates').ResourceDuplicateCandidate | null }} props
 */
const ResourceDuplicates = ({ candidate }) => {
  const duplicates =
    rd.tryGet(useResourceDuplicates(candidate, myServices)) ?? [];
  const routes = useBrowsingWorkspaceRoutes(myServices);
  const signature = duplicates.map(resource => resource.id).join(',');
  const [dismissedSignature, setDismissedSignature] = useState(null);

  if (duplicates.length === 0 || signature === dismissedSignature) {
    return null;
  }

  return (
    <div className={styles.ResourceDuplicates}>
      <div className={styles.details}>
        <Grid className="stack-XS">
          <GridCell>
            <h3>
              <img
                src="/images/icon_warning_black.svg"
                className={styles.icon}
                alt=""
              />
              Potential duplicate found
            </h3>
          </GridCell>
          <GridCell width="auto">
            <PressStud
              label="Dismiss"
              appearance="silent"
              size="S"
              action={() => setDismissedSignature(signature)}
            />
          </GridCell>
        </Grid>
        {duplicates.map(resource => (
          <CellResource
            key={resource.id}
            item={resource}
            className={styles.resource}
            actions={[
              {
                text: 'View Profile',
                link: routes.contacts.detail(resource.id),
                target: '_blank'
              }
            ]}
          />
        ))}
      </div>
    </div>
  );
};

export default ResourceDuplicates;
